/*
 * @Author: 顾喜斌 xibin_gu@163.com
 * @Date: 2023-01-17 14:15:00
 * @LastEditors: 顾喜斌 xibin_gu@163.com
 * @LastEditTime: 2023-02-24 12:15:12
 */

const router_modular = [
    {
        path: '/notWeixin',
        name: 'notWeixin',
        component: () => import('@/views/NotWeixin'),
        meta: {
            title: '非微信内部浏览器'
        }
    },
    {
        path: '/clearStorage',
        name: 'clearStorage',
        component: () => import('@/views/ClearStorage'),
        meta: {
            title: '清除缓存',
            isInWhileList: true
        }
    },
    {
        path: '/notFollowed',
        name: 'notFollowed',
        component: () => import('@/views/notFollowed/NotFollowed'),
        meta: {
            title: '未关注公众号'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/LoginView'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/login/RegisterView'),
        meta: {
            title: '注册'
        }
    },
    {
        path: '/loginSuccess',
        name: 'loginSuccess',
        component: () => import('@/views/login/LoginSuccess'),
        meta: {
            title: '登录成功'
        }
    },
    {
        path: '/registerSuccess',
        name: 'registerSuccess',
        component: () => import('@/views/login/RegisterSuccess'),
        meta: {
            title: '注册成功'
        }
    },
    {
        path: '/resetPwd',
        name: 'resetPwd',
        component: () => import('@/views/resetPwd/ResetPwd'),
        meta: {
            title: '重置密码'
        }
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('@/views/home/IndexView'),
        meta: {
            title: '首页'
        }
    },
    {
        path: '/moreApp',
        name: 'moreApp',
        component: () => import('@/views/home/MoreAppView'),
        meta: {
            title: '应用'
        }
    },
    {
        path: '/bindPallet',
        name: 'bindPallet',
        component: () => import('@/views/bindPallet/BindIndex'),
        meta: {
            title: '绑定托盘'
        }
    },
    {
        path: '/tray',
        name: 'tray',
        component: () => import('@/views/bindPallet/BindTray'),
        meta: {
            title: '绑定托盘'
        }
    },
    {
        path: '/userCenter',
        name: 'userCenter',
        component: () => import('@/views/userCenter/UserCenter'),
        meta: {
            title: '个人中心'
        }
    },
    {
        path: '/account',
        name: 'account',
        component: () => import('@/views/userCenter/AccountView'),
        meta: {
            title: '账号设置'
        }
    },
    {
        path: '/modifyName',
        name: 'modifyName',
        component: () => import('@/views/userCenter/ModifyName'),
        meta: {
            title: '修改昵称'
        }
    },
    {
        path: '/modifyCarNo',
        name: 'modifyCarNo',
        component: () => import('@/views/userCenter/ModifyCarNo'),
        meta: {
            title: '修改车牌'
        }
    },
    {
        path: '/cashOut',
        name: 'cashOut',
        component: () => import('@/views/userCenter/CashOut'),
        meta: {
            title: '提现'
        }
    },
    {
        path: '/paymentCode',
        name: 'paymentCode',
        component: () => import('@/views/userCenter/PaymentCode'),
        meta: {
            title: '付款码'
        }
    },
    {
        path: '/recharge',
        name: 'recharge',
        component: () => import('@/views/userCenter/RechargeView'),
        meta: {
            title: '充值'
        }
    },
    {
        path: '/carRecharge',
        name: 'carRecharge',
        component: () => import('@/views/userCenter/CarRechargeView'),
        meta: {
            title: '充电桩充值'
        }
    },
    {
        path: '/carRechargeSuccess',
        name: 'carRechargeSuccess',
        component: () => import('@/views/userCenter/CarRechargeSuccess'),
        meta: {
            title: '充电缴费成功'
        }
    },
    {
        path: '/rechargeSuccess',
        name: 'rechargeSuccess',
        component: () => import('@/views/userCenter/RechargeSuccess'),
        meta: {
            title: '充值成功'
        }
    },
    {
        path: '/order',
        name: 'order',
        component: () => import('@/views/userCenter/BillView'),
        meta: {
            title: '账单',
            keepAlive: true
        }
    },
    {
        path: '/orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/userCenter/BillDetail'),
        meta: {
            title: '账单详情',
            keepAlive: true
        }
    },
    {
        path: '/nutritionalAnalysis',
        name: 'nutritionalAnalysis',
        component: () => import('@/views/userCenter/NutritionalAnalysis'),
        meta: {
            title: '营养分析',
            keepAlive: true
        }
    },
    {
        path: '/nutritionalMeal',
        name: 'nutritionalMeal',
        component: () => import('@/views/userCenter/NutritionalMeal'),
        meta: {
            title: '营养分析'
        }
    },
    {
        path: '/mealReport',
        name: 'mealReport',
        component: () => import('@/views/userCenter/MealReport'),
        meta: {
            title: '报餐',
            keepAlive: true
        }
    },
    {
        path: '/mealReportQuestionnaire',
        name: 'mealReportQuestionnaire',
        component: () => import('@/views/userCenter/MealReportQuestionnaire'),
        meta: {
            title: ''
        }
    },
    {
        path: '/feedback',
        name: 'feedback',
        component: () => import('@/views/userCenter/FeedbackView'),
        meta: {
            title: '建议与反馈',
            keepAlive: true
        }
    },
    {
        path: '/feedbackDetail',
        name: 'feedbackDetail',
        component: () => import('@/views/userCenter/FeedbackDetail'),
        meta: {
            title: '反馈详情'
        }
    },
    {
        path: '/bindCardModule',
        name: 'bindCardModule',
        component: () => import('@/views/userCenter/BindCardModule'),
        meta: {
            title: '绑卡'
        }
    },
    {
        path: '/foodMenu',
        name: 'foodMenu',
        component: () => import('@/views/userCenter/FoodMenuView'),
        meta: {
            title: '一周菜单'
        }
    },
    {
        path: '/changePassWord',
        name: 'changePassWord',
        component: () => import('@/views/userCenter/changePassWord'),
        meta: {
            title: '修改密码'
        }
    },
    {
        path: '/preMeals',
        name: 'preMeals',
        component: () => import('@/views/userCenter/preMealsView'),
        meta: {
            title: '预订点餐'
        }
    },
    {
        path: '/confirmOrder',
        name: 'confirmOrder',
        component: () => import('@/views/userCenter/confirmOrder'),
        meta: {
            title: '确认订单信息'
        }
    },
    {
        path: '/confirmSuccess',
        name: 'confirmSuccess',
        component: () => import('@/views/userCenter/confirmSuccess'),
        meta: {
            title: '支付结果页'
        }
    },
    {
        path: '/preOrder',
        name: 'preOrder',
        component: () => import('@/views/userCenter/PreOrder'),
        meta: {
            title: '预订订单',
            keepAlive: true
        }
    },
    {
        path: '/dinnerInHouse',
        name: 'dinnerInHouse',
        component: () => import('@/views/userCenter/DinnerInHouse'),
        meta: {
            title: '堂食点餐',
            keepAlive: true
        }
    },
    {
        path: '/valuation',
        name: 'valuation',
        component: () => import('@/views/userCenter/Valuation'),
        meta: {
            title: '评价'
        }
    },
    {
        path: '/foodDisplay',
        name: 'foodDisplay',
        component: () => import('@/views/userCenter/FoodDisplay'),
        meta: {
            title: '热销餐品'
        }
    },
    {
        path: '/foodDetail',
        name: 'foodDetail',
        component: () => import('@/views/userCenter/FoodDetail'),
        meta: {
            title: '餐品详情'
        }
    },
    {
        path: '/recipeDisplay',
        name: 'recipeDisplay',
        component: () => import('@/views/userCenter/RecipeDisplay'),
        meta: {
            title: '菜品展示'
        }
    },
    {
        path: '/recipeNewDisplay',
        name: 'recipeNewDisplay',
        component: () => import('@/views/userCenter/RecipeNewDisplay'),
        meta: {
            title: '新品推送'
        }
    },
    {
        path: '/recipeDetail',
        name: 'recipeDetail',
        component: () => import('@/views/userCenter/RecipeDetail'),
        meta: {
            title: '菜品详情'
        }
    },
    // 扫码点餐
    {
        path: '/scanOrdering',
        name: 'scanOrdering',
        component: () => import('@/views/userCenter/ScanOrdering'),
        meta: {
            title: '扫码点餐'
        }
    },
    // 扫码点餐确认页
    {
        path: '/scanConfirmOrder',
        name: 'scanConfirmOrder',
        component: () => import('@/views/userCenter/ScanConfirmOrder'),
        meta: {
            title: '确认订单信息'
        }
    },
    // 扫码点餐结果页
    {
        path: '/scanConfirmSuccess',
        name: 'scanConfirmSuccess',
        component: () => import('@/views/userCenter/ScanConfirmSuccess'),
        meta: {
            title: '确认订单信息'
        }
    },
    // 汉阳点餐
    {
        path: '/hyPreMeals',
        name: 'hyPreMeals',
        component: () => import('@/views/hanyang/hyPreMealsView'),
        meta: {
            title: '点餐'
        }
    },
    // 汉阳确认订单信息
    {
        path: '/hyConfirmOrder',
        name: 'hyConfirmOrder',
        component: () => import('@/views/hanyang/hyConfirmOrder'),
        meta: {
            title: '确认订单信息'
        }
    },
    // 汉阳支付结果页面
    {
        path: '/hyConfirmSuccess',
        name: 'hyConfirmSuccess',
        component: () => import('@/views/hanyang/hyConfirmSuccess'),
        meta: {
            title: '支付结果页'
        }
    },
    {
        path: '/foodTaboos',
        name: 'foodTaboos',
        component: () => import('@/views/foodTaboos/foodTaboosView'),
        meta: {
            title: '饮食禁忌'
        }
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('@/views/aboutUs/AboutView'),
        meta: {
            title: '了解我们',
            isInWhileList: true  // 白名单 不校验token
        }
    },
    {
        path: '/middleJumpPage',
        name: 'middleJumpPage',
        component: () => import('@/views/middlePage/middleJumpView'),
        meta: {
            title: '正在跳转',
            isInWhileList: true  // 白名单 不校验token
        }
    },
    {
        path: '/httpJumpPage',
        name: 'httpJumpPage',
        component: () => import('@/views/middlePage/httpJumpView'),
        meta: {
            title: '正在跳转',
            isInWhileList: true  // 白名单 不校验token
        }
    },
    {
        path: '/payNotWeixin',
        name: 'payNotWeixin',
        component: () => import('@/views/middlePage/payNotWeixin'),
        meta: {
            title: '非微信内部浏览器',
            isSpecialPage: true     // 特殊页 与用户无关
        }
    },
    {
        path: '/paymentPage',
        name: 'paymentPage',
        component: () => import('@/views/middlePage/paymentView'),
        meta: {
            title: '支付',
            isSpecialPage: true     // 特殊页 与用户无关
        }
    },
    {
        path: '/notTokenPage',
        name: 'notTokenPage',
        component: () => import('@/views/notTokenPage/NotTokenPage'),
        meta: {
            title: '自动登录中'
        }
    },
    {
        path: '/openMiniWechat',
        name: 'openMiniWechat',
        component: () => import('@/views/openMiniWechat/openMiniWechat'),
        meta: {
            title: 'open小程序'
        }
    }
]
export default router_modular